<template>
  <div
    v-if="content"
    class="case-wrapper"
    v-editable="content"
  >
    <div class="case-content">
      <h2 v-html="content.title"></h2>
      <ul>
        <li>
          <fai class="icon" icon="calendar-alt"></fai>
          <span v-html="content.product"></span>
        </li>
        <li>
          <fai class="icon" icon="users"></fai>
          <span v-html="content.cap"></span>
        </li>
        <li>
          <fai class="icon" icon="comment"></fai>
          <span v-html="content.text"></span>
        </li>
      </ul>
    </div>
    <div class="case-img" :style="`background-image:url('${content.img}')`"></div>
  </div>
</template>

<script>
  import VueMarkdown from "vue-markdown";

  export default {
    components: {
      VueMarkdown
    },
    props: {
      content: null
    }
  };
</script>

<style lang="scss">
  .case-wrapper {
    width: 100%;
    height: 100%;
    display: flex;

    .case-img {
      flex: 4;
      background-position: center;
      background-repeat:no-repeat;
      background-size:cover;
    }

    .case-content {
      background-color:$primary;
      flex: 2;
      h2 {
        width:100%;
        background-color:$primary-D2;
        color:#fff;
        padding:1em 0.5em;
        text-align: center;
      }
      > ul {
        padding:2em 1em;
        > li {
          color:#fff;
          margin-bottom:2em;
          display: flex;
          align-items: flex-start;
          .icon {
            font-size:1em;
            margin-right:10px;
          }
          span {

          }
        }
      }
    }
  }
  #seminaires .cases .slider {
    width:100%;
    margin:auto;
  }

  @media screen and (max-width: $desktop) {
    #seminaires .cases .case-wrapper {
      flex-direction: column-reverse;
    }
  }
</style>
